<template>
    <transition  name="message-controller__wrap-anim">
        <div v-if="messages.length > 0" class="message-controller">
            <a href="#" @click="removeAllMessages" class="message-controller__close">×</a>
            <p :key="index" v-for="(message,index) in messages" class="message-controller__item" :class="cssClass[index]">
                <i v-if="type[index] == 'success'" class="glyphicon glyphicon-ok glyphicon--success"></i>
                <i v-else class="glyphicon glyphicon-exclamation-sign glyphicon--error"></i>
                {{message}}
            </p>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'message-controller',
        data() {
            return {
                messages: [],
                type: [],
                cssClass: []

            }
        },
        created() {
            this.$eventHub.$on('openMessageController',this.open);
        },
        beforeDestroy() {
            this.$eventHub.$off('openMessageController');
        },
        methods: {
            open(type, message) {
                this.messages.push(message);
                this.type.push(type);


                switch (type) {
                    case "success" :
                        this.cssClass.push('message-controller--success');
                        break;
                    case "error" :
                        this.cssClass.push('message-controller--error');
                        break;
                }

                setTimeout( () => {
                    this.messages.shift();
                    this.type.shift();
                    this.cssClass.shift();

                } , 6000);

            },
            removeAllMessages() {
                this.messages=[];
                this.type=[];
                this.cssClass=[];
            }

        }
    }
</script>

<style lang="scss" scoped>
    .message-controller {
        position: fixed;
        z-index: 1090;
        top: 0;
        margin-left: auto;
        margin-right: auto;
        left: -50px;
        width: 300px;
        border-bottom-right-radius: 190px;
        background-color: var(--red);
        padding: 10px 30px 10px 70px;
        transform: translateY(0) rotate(0deg);
        transform-origin: center bottom;
        font-family: 'Bebas Neue', cursive;
        &__item {
            position: relative;
            margin: 10px 0;
            display: flex;
            align-items: center;
        }
        &__close {
            color: white;
            font-size: 26px;
            position: absolute;
            right: 12px;
            top: 0;

        }
        &--success {
            //color: #18ff0c;

        }
        &--error {
            //color: #d63b3b;
        }
        &__wrap-anim {
            &-enter-active,
            &-leave-active {

                transition: all .5s;
            }
            &-enter,
            &-leave-to {
                opacity: 0;
                transform: translateY(-400px) rotate(-90deg);
            }
        }
        .glyphicon {
            font-size: 24px;
            margin-right: 9px;
            top: -2px;
        }
        .glyphicon--success {
            color: #18ff0c;
        }
        .glyphicon--error {
            color: #d63b3b;
        }

    }
</style>
